import React from "react";
import { altImageUrls } from "../utils/media";

/**
 * Serves AVIF/WebP when the browser supports them, original file otherwise.
 * Layout is controlled by the same className/style as a plain <img>.
 */
export default function OptimizedImg({
  src,
  alt,
  className,
  style,
  pictureStyle,
  width,
  height,
  loading = "lazy",
  decoding = "async",
  fetchPriority,
  avif = true,
  onLoad,
  onError,
}) {
  const { avif: avifSrc, webp, fallback } = altImageUrls(src);
  return (
    <picture style={pictureStyle}>
      {avif ? <source type="image/avif" srcSet={avifSrc} /> : null}
      <source type="image/webp" srcSet={webp} />
      <img
        src={fallback}
        alt={alt}
        className={className}
        style={style}
        width={width}
        height={height}
        loading={loading}
        decoding={decoding}
        fetchpriority={fetchPriority}
        onLoad={onLoad}
        onError={onError}
      />
    </picture>
  );
}